import { useMutation } from '@tanstack/react-query'
import { getAffiliateProgram } from '../../../service/event'

function useGetAffiliateProgramByCode() {
  return useMutation({
    mutationKey: ['get-affiliate-program'],
    mutationFn: getAffiliateProgram,
  })
}

export default useGetAffiliateProgramByCode
